export namespace NBlogPostPageType {
    export const typeId = 'blog-post';
    export interface ITypeData {
        tags?: number[];
        author?: string;
        date?: Date;
        reading_time?: string;
        top_image?: string;
    }
}
